export const formFields = {
  dspName: {
      key: 'dspName',
      type: 'text',
      label: 'DSP Name',
      placeholder: 'Enter DSP Name',
      required: true,
      requiredMessage: 'This field is required.',
      minLength: 3,
      minLengthMessage: 'Minimum 3 character allowed.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 character allowed.',
      displayLayout: 'col-md-12',
      tooltip: '<div> DSP Name </div>',
      pattern: /^[A-Za-z][A-Za-z0-9]*$/,
      patternMessage: 'Platform Name must start with a letter. Allowed characters are a-z & A-Z, 0-9, space is not allowed'
      // patternMessage: 'Space is not allowed', 
  },
};